import { Injectable } from '@angular/core';
import { DadosUsuario } from '@aslib/common/src/models/dados-usuario';

import { AslibAuthService } from '@aslib/security';
 
 
@Injectable()

export class BaseConfig {
 
  private ambiente: number;

  static uri: string;
 
  private dadosLogin: any;
 
  constructor(private aslibAuthService: AslibAuthService){

    this.aslibAuthService.ambientConfig();

    this.ambiente = this.aslibAuthService.ambiente.Id;

    this.dadosLogin = this.aslibAuthService.loginData;
    
   // this.dadosUsuario = this.aslibAuthService.loginData?.DadosUsuario;
  }
 
  public getBaseUrlApi(): string {

    BaseConfig.getBaseUrl(this.ambiente);

    const uri: string = BaseConfig.uri;

    return uri;

  }

  public getUsuarioLogado(): DadosUsuario | undefined {
    return  this.dadosLogin !== null ? this.dadosLogin.DadosUsuario : undefined;
  }
 
 
  public static getBaseUrl(idAmbiente: number){
 
    switch (idAmbiente) {

      case 9999: {
 
        this.uri= "http://localhost:29767"

        break;

      }

      case 4: {
 
        this.uri = "https://dsistemasweb.sefaz.ba.gov.br/sistemas/sarf/api"

        break;

      }

      case 3: {
 
        this.uri = "https://tsistemasweb.sefaz.ba.gov.br/sistemas/sarf/api"

        break;

      }

      case 2: {
 
        this.uri = "https://hsistemasweb.sefaz.ba.gov.br/sistemas/sarf/api"

        break;

      }

      default: {
 
        this.uri = "https://sistemasweb.sefaz.ba.gov.br/sistemas/sarf/api"

        break;

      }

    }

  }

}


// WEBPACK FOOTER //
// ./src/app/shared/service/base-config.service.ts